
document.addEventListener("DOMContentLoaded", async () => {
  const API_URL = "http://hyphenaireview.letshyphen.com/api/product/reviews/metrics";

  try {
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer 0d059f813889a003ff6c0134fe6d0c1e7f71a2a6ddfdfbf50af35ac756d2a4"
      }
    });

    const json = await response.json();

    // Validate response structure
    if (!json || !json.success || !json.data) return;

    const data = json.data;
    // console.log(data,"metrics>>>>>>>>>>>>");

    /* =========================
       1. UPDATE STATS (DATA-DRIVEN)
    ========================= */

    const statValues = document.querySelectorAll(".stat-value");

    statValues.forEach((el) => {
      const type = el.getAttribute("data-type");

      if (!type) return;

      switch (type) {
        case "reviews":
          // Only update if value exists
          if (data.totalReviews !== undefined) {
            el.innerText = data.totalReviews;
          }
          break;

        case "rating":
          if (data.average_rating !== undefined) {
            el.innerText = data.average_rating;
          }
          break;

        case "sentiment":
          if (data.positive_sentiment_percentage !== undefined) {
            el.innerText = data.positive_sentiment_percentage + "%";
          }
          break;

        default:
          // Do nothing for unknown types
          break;
      }
    });

    /* =========================
       2. UPDATE AI CVS CARD
    ========================= */

    const aiCard = document.querySelector(".cvs-card.ai-response");
    if (!aiCard) return;

    const items = aiCard.querySelectorAll(".cvs-item");

    // Ensure highlights exist
    if (!data.highlights || !Array.isArray(data.highlights)) return;

    // Take top 5 highlights
    const topHighlights = data.highlights.slice(0, 5);

    items.forEach((item, index) => {
      const highlight = topHighlights[index];
      if (!highlight) return;

      const textEl = item.querySelector(".item-text");
      const badgeEl = item.querySelector(".badge");

      // Update text safely
      if (textEl && highlight.text) {
        textEl.innerText = highlight.text;
      }

      // Update badge safely
      if (badgeEl && highlight.count) {
        badgeEl.innerText = highlight.count;
      }
    });

  } catch (error) {
    console.error("API fetch failed:", error);
  }
});